<script lang="ts">
    import {onDestroy} from 'svelte'
    import {Link} from 'svelte-routing'
    import Menu from '../../../#common/menu/menu.svelte'
    import IconifyIcon from '@iconify/svelte'
    import envelopeIcon from '@iconify/icons-fa-solid/envelope'
    import twitterIcon from '@iconify/icons-fa-brands/twitter'
    import telegramIcon from '@iconify/icons-fa-brands/telegram-plane'
    import mediumIcon from '@iconify/icons-fa-brands/medium-m'
    import discordIcon from '@iconify/icons-fa-brands/discord'
    import instagramIcon from 'src/components/#assets/instagram.svg'
    import logo from 'src/components/#assets/logo.svg'
    import miniLogo from 'src/components/#assets/realis-mini.svg'
    import toTop from 'src/components/#assets/top-icon.svg'
    import menuArrow from 'src/components/#assets/menu-arrow.svg'
    import footer from 'src/components/#assets/footer.svg'
    import googlePlayIcon from 'src/components/#assets/google-play-icon.svg'
    import listeriaIcon from 'src/components/#assets/listeria.svg'
    import dragonsIcon from 'src/components/#assets/dragons.jpg'
    import catsIcon from 'src/components/#assets/cats.jpg'
    import foxesIcon from 'src/components/#assets/foxes.jpg'
    import cookie from 'src/components/#assets/cookie.svg'
    import {autoScrollTop} from 'src/components/main/#common/helpers'
    import {isLoggedIn} from 'src/services/auth'
    import { link } from "svelte-routing"

    export let home = false
    let year = new Date().getFullYear()
    let zoomLevel = Math.round(window.devicePixelRatio * 100)
    let mobileMenuOpened = false
    let url = window.location.pathname
    let widget = false
    let dropdownOpen = false

    if (typeof window !== 'undefined') {
        onDestroy(autoScrollTop({
            onPushState: true,
            onReloadPage: true,
        }))
    }

    let showToTop = false
    let lastScrollPosition = 0
    window.addEventListener('scroll', function() {
        showToTop = window.scrollY != 0 && lastScrollPosition > window.scrollY && lastScrollPosition > 1000
        lastScrollPosition = window.scrollY
    })

    window.addEventListener('resize', function(){
        zoomLevel = Math.round(window.devicePixelRatio * 100)
    })

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }

    function goToTop() {
        window.scrollTo(0, 0)
        showToTop = false
        widget = false
    }

    let userCookie = localStorage.getItem('userCookie')

    if (!userCookie) {
        localStorage.setItem('userCookie', 'not')
        userCookie = 'not'
    }

    function cookieAgree() {
        localStorage.setItem('userCookie', 'allow')
        userCookie = 'allow'
    }
</script>

<div class="app" class:zoom-110={zoomLevel === 110} class:zoom-125={zoomLevel === 125} class:zoom-150={zoomLevel === 150} class:home-page={home}>
    <header class="header">
        <div class="container">
            <div class="row d-flex align-items-center justify-content-space-between flex-nowrap">
                <div class="col d-flex d-md-none">
                    <!--
                    <button class="hamburger-btn {mobileMenuOpened ? 'active' : ''}"
                            on:click={() => { mobileMenuOpened = !mobileMenuOpened }}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    -->
                    <Link to="/" class="logo" on:click={() => { mobileMenuOpened = false }}>
                        <img src="{miniLogo}" class="logotype logo-mobile" alt="logo">
                    </Link>
                </div>
                <div class="col-auto d-none d-md-block">
                    <Link to="/" class="logo" on:click={() => { mobileMenuOpened = false }}>
                        <img src="{logo}" class="logotype logo-pc" alt="logo">
                    </Link>
                </div>
                <div class="col-auto d-flex align-items-center">
                    <!--
                    <nav class="menu" class:active={mobileMenuOpened}>
                        <div class="menu-item" class:active={url === '/about'} class:open={dropdownOpen}>
                            <div class="menu-item-dropdown-title" on:click={() => dropdownOpen = !dropdownOpen}>
                                <span>About</span>
                                <img src="{menuArrow}" class="menu-arrow" alt="">
                            </div>
                            <div class="menu-item-dropdown-list">
                                <a href="/about" class="menu-dropdown-item" on:click={() => {dropdownOpen = false; mobileMenuOpened = false}} use:link><span>About us</span></a>
                                <a href="/about#roadmap" class="menu-dropdown-item" on:click={() => {dropdownOpen = false; mobileMenuOpened = false}}><span>Roadmap</span></a>
                                <a href="https://docs.realis.network" class="menu-dropdown-item" target="_blank" on:click={() => {dropdownOpen = false; mobileMenuOpened = false}}><span>Litepaper</span></a>
                            </div>
                        </div>
                        <Link to="games" class="menu-item {url === '/games' ? 'active' : ''}" on:click={() => { mobileMenuOpened = false }}><span>Games</span></Link>-->
                        <!--<Link to="marketplace" class="menu-item {url === '/marketplace' ? 'active' : ''}" on:click={() => { mobileMenuOpened = false }}><span>Marketplace</span></Link>-->
                        <!--<a href="https://nft-mint.realis.network" class="menu-item mint-item" target="_blank"><span>MINT</span></a>-->
                        <!--<Link to="support" class="menu-item {url === '/support' ? 'active' : ''}" on:click={() => { mobileMenuOpened = false }}><span>Support</span></Link>
                        <Link to="blog" class="menu-item {url === '/blog' ? 'active' : ''}" on:click={() => { mobileMenuOpened = false }}><span>Blog</span></Link>
                        <div class="social-links d-md-none">
                            <a href="https://twitter.com/realisnetwork" target="_blank">
                                <IconifyIcon icon={twitterIcon}/>
                            </a>
                            <a href="https://t.me/RealisANN" target="_blank">
                                <IconifyIcon icon={telegramIcon}/>
                            </a>
                            <a href="mailto:hello@realis.network">
                                <IconifyIcon icon={envelopeIcon}/>
                            </a>
                            <a href="https://realisnetwork.medium.com" target="_blank">
                                <IconifyIcon icon={mediumIcon}/>
                            </a>
                            <a href="https://www.instagram.com/realis.network/" target="_blank">
                                <img src={instagramIcon} class="instagram-icon" alt="">
                            </a>
                            <a href="https://discord.gg/realis" target="_blank">
                                <IconifyIcon icon={discordIcon}/>
                            </a>
                        </div>
                    </nav>
                    -->
                </div>
                <div class="col d-none d-sm-block"></div>
                <div class="col-auto d-flex align-items-center">
                    {#if $isLoggedIn}
                        <Link to="account" on:click={() => { mobileMenuOpened = false }} class="d-none d-lg-block btn-primary account-btn">
                            <div class="account-text"><span>Account</span></div>
                        </Link>
                    {:else}
                        <Link to="login" on:click={() => { mobileMenuOpened = false }} class="menu-item login-btn {url === '/login' ? 'active' : ''}">Log in</Link>
                        <Link to="register" on:click={() => { mobileMenuOpened = false }} class="btn btn-primary register-btn"><span>Sign up</span></Link>
                    {/if}
                </div>
            </div>
        </div>
    </header>
    {#if $isLoggedIn}
        <Menu template="main"/>
    {/if}

    <slot name="content" />

    <footer class="footer" style="--Footer:url({footer});">
        <div class="container">
            <div class="row">
                <div class="col-6 col-md-9">
                    <Link to="/" class="logo d-md-none">
                        <img src="{logo}" class="footer-logotype" alt="logo">
                    </Link>
                    <!--
                    <nav class="menu d-none d-md-block">
                        <Link to="about" class="menu-item">About</Link>
                        <a href="https://docs.realis.network/" class="menu-item" target="_blank">Litepaper</a>
                        <Link to="games" class="menu-item">Games</Link>
                        <Link to="marketplace" class="menu-item">Marketplace</Link>
                        <Link to="blog" class="menu-item">Blog</Link>
                    </nav>
                    -->
                </div>
                <div class="col-6 col-md-3">
                    <div class="social-links">
                        <!--
                        <a href="https://t.me/RealisANN" class="social-link" target="_blank">
                            <IconifyIcon icon={telegramIcon}/>
                        </a>
                        <a href="https://twitter.com/realisnetwork" class="social-link" target="_blank">
                            <IconifyIcon icon={twitterIcon}/>
                        </a>
                        -->
                        <a href="mailto:support@realis.network" class="social-link">
                            <IconifyIcon icon={envelopeIcon}/>
                        </a>
                    </div>
                </div>
                <div class="col-12 d-md-none">
                    <nav class="menu d-md-none">
                        <!--
                        <Link to="about" class="menu-item">About</Link>
                        <a href="https://docs.realis.network/" class="menu-item" target="_blank">Litepaper</a>
                        <Link to="games" class="menu-item">Games</Link>
                        <Link to="marketplace" class="menu-item">Marketplace</Link>
                        <Link to="blog" class="menu-item">Blog</Link>
                        <Link to="support" class="menu-item">Support</Link>
                        -->
                        <Link to="policy" class="menu-item">Privacy Policy</Link>
                        <Link to="terms" class="menu-item">Terms of Use</Link>
                    </nav>
                </div>
            </div>
            <hr>
            <div class="row align-items-center d-mobile-reverse">
                <div class="col-md-5">
                    <div class="copyright">Realis Digital Services. Save Vukovića 9, stan 2, Serbia. <br>&copy; All Rights Reserved { year }.</div>
                </div>
                <div class="col-md-2 d-none d-md-block">
                    <Link to="/" class="logo">
                        <img src="{logo}" class="footer-logotype" alt="logo">
                    </Link>
                </div>
                <div class="col-md-5 d-none d-md-block">
                    <div class="text-right">
                        <div class="after-footer-links">
                            <!--
                            <Link to="support" class="footer-link">Support</Link>
                            -->
                            <Link to="policy" class="footer-link">Privacy Policy</Link>
                            <Link to="terms" class="footer-link">Terms of Use</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <div class="to-top" on:click={goToTop} class:visible={showToTop}>
        <img src="{toTop}" alt="">
    </div>
    <!--
    <div class="games-widget">
        <div class="widget-content" class:active={widget}>
            <a href="https://mergefox.page.link/site" target="_blank" class="game-app-icon">
                <img src="{foxesIcon}" alt="">
                <div>Crypto<br>Fox</div>
            </a>
            <a href="https://dragonmerge.page.link/site" target="_blank" class="game-app-icon">
                <img src="{dragonsIcon}" alt="">
                <div>Crypto<br>Dragons</div>
            </a>
            <a href="https://mergecat.page.link/site" target="_blank" class="game-app-icon">
                <img src="{catsIcon}" alt="">
                <div>Crypto<br>Cats</div>
            </a>
        </div>
        <div class="widget-icon" on:click={() => {widget = !widget}}>
            <img src="{googlePlayIcon}" alt="">
        </div>
    </div>
    -->
    <div class="cookie-window" class:d-none={userCookie && userCookie == 'allow'}>
        <div class="container">
            <div class="cookie-icon">
                <img src="{cookie}" alt="">
            </div>
            <div class="cookie-text">
                We use cookies to improve user experience. You can read more about our Cookie Policy in our
                <Link to="policy">Privacy policy</Link>
            </div>
            <div class="cookie-button">
                <button class="btn btn-primary" on:click={cookieAgree}>
                    <span>Yes, I agree</span>
                </button>
            </div>
        </div>
    </div>
</div>

<style lang="postcss">
    .app.zoom-110 {
        zoom: 0.91;
    }

    .app.zoom-125 {
        zoom: 0.8;
    }

    .app.zoom-150 {
        zoom: 0.67;
    }

    .header {
        background: rgba(1, 7, 10, 0.7);
        position: fixed;
        width: 100%;
        height: 110px;
        backdrop-filter: blur(10px);
        border-bottom: 2px solid #282D39;
        top: 0;
        left: 0;
        z-index: 7;
        right: 0;
        display: flex;
        align-items: center;
    }

    .home-page .header {
        width: 1364px;
        left: 50%;
        transform: translate(-50%, 0);
        top: 20px;
        border-radius: 8px 8px;
    }

    .header .menu {
        margin-left: 90px;
    }

    .instagram-icon {
        width: 20px;
    }

    .header :global(.menu-item) {
        font-size: 18px;
        line-height: 22px;
        color: white;
        font-weight: 500;
        text-decoration: none;
        margin-right: 46px;
        padding: 44px 0;
        position: relative;
        display: inline-block;
        transition: .25s;
    }

    .header :global(.menu-item .menu-item-dropdown-title) {
        color: white;
        text-decoration: none;
        transition: .25s;
        cursor: pointer;
        user-select: none;
    }

    .header :global(.menu-item.active:after) {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(255, 93, 28, 0) 0%, rgba(255, 93, 28, 0.3) 100%);
        width: 100%;
        height: 50%;
        border-bottom: 2px solid #FF5D1C;
        z-index: -1;
    }

    .header :global(.menu-item:hover) {
        color: #dfdfdf;
    }

    .header :global(.menu-item .menu-item-dropdown-title:hover) {
        color: #dfdfdf;
    }

    .header :global(.btn-secondary) {
        margin-right: 8px;
    }

    .header :global(.btn-primary.account-btn),
    .header :global(.btn-primary.register-btn) {
        padding: 14px 20px;
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
    }

    .menu-item-dropdown-list {
        position: absolute;
        display: none;
        background: #282D39;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 3px;
        padding: 15px 20px;
        margin-top: 10px;
        min-width: 180px;
        border: 1px solid #91A2FA;
    }

    .menu-dropdown-item {
        font-size: 16px;
        color: #A0AEC0;
        display: table;
        font-weight: 300;
        text-decoration: none;
        white-space: nowrap;
        transition: .25s;
        text-transform: none;
    }

    .menu-dropdown-item + .menu-dropdown-item {
        margin-top: 18px;
    }

    .header :global(.menu-item .menu-item-dropdown-title .menu-arrow) {
        margin: 7px 0 0 10px;
        vertical-align: top;
        transform: rotate(180deg);
        transition: .25s;
    }

    .header :global(.menu-item.open .menu-item-dropdown-title .menu-arrow) {
        transform: rotate(0);
    }

    .header :global(.menu-item.open .menu-item-dropdown-list) {
        display: block;
    }

    .menu-dropdown-item:hover {
        color: white;
    }

    .logotype {
        display: block;
        width: 130px;
    }

    .footer {
        background: rgba(255, 255, 255, 0.05) var(--Footer) no-repeat center bottom;
        border-top: 2px solid #282D39;
        padding: 50px 0 40px;
        position: relative;
        z-index: 2;
    }

    .footer-logotype {
        width: 180px;
    }

    .footer hr {
        background: #5e5e6d;
        height: 1px;
        opacity: 1;
        margin: 50px 0 40px;
    }

    .footer :global(.menu-item) {
        font-size: 20px;
        line-height: normal;
        color: white;
        text-decoration: none;
        transition: .25s;
    }

    .footer :global(.menu-item:last-child) {
        margin-right: 0;
    }

    .footer :global(.logo) {
        text-align: center;
        display: block;
    }

    .social-links {
        display: flex;
        justify-content: flex-end;
    }

    .social-link {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
        background: white;
        border-radius: 8px;
    }

    .footer :global(.social-link:not(:last-child)) {
        margin-right: 50px;
    }

    .social-link :global(svg) {
        color: #0F1417;
        font-size: 24px;
    }

    .footer :global(.menu-item:not(:last-child)) {
        margin-right: 70px;
    }

    .footer :global(.menu-item:hover) {
        color: #dfdfdf;
    }

    .footer-link {
        font-size: 14px;
        color: white;
        text-decoration: none;
        margin-left: 30px;
    }

    .footer-link:first-child {
        margin-left: 0;
    }

    .footer-link:hover {
        color: white;
        text-decoration: underline;
    }

    .copyright {
        font-size: 14px;
        color: #BDBDBD;
    }

    .after-footer-links {
        text-align: right;
    }

    .social-links a:first-child {
        margin-left: 0;
    }

    .footer :global(.footer-link) {
        font-size: 14px;
        color: #BDBDBD;
        text-decoration: none;
        transition: .25s;
    }

    .footer :global(.footer-link:not(:last-child)) {
        margin-right: 26px;
    }

    .footer :global(.footer-link:hover) {
        color: white;
    }

    .app {
        font-size: 18px;
        line-height: 18.16px;
        color: #1e1e1e;
        font-weight: 400;
        background: #01070A;
        font-family: 'Inter', sans-serif;
        letter-spacing: 1px;

        :global {
            @import 'src/styles/app.pcss';
        }
    }

    .hamburger-btn {
        width: 40px;
        height: 40px;
        border: 0;
        margin-right: 20px;
        padding: 11px;
        border-radius: 3px;
        background: #282D39;
    }

    .hamburger-btn span:first-child {
        margin-top: 0;
    }

    .hamburger-btn span:last-child {
        margin-bottom: 0;
    }

    .hamburger-btn span {
        height: 2px;
        background: white;
        width: 18px;
        margin: 4px 0;
        display: block;
        border-radius: 2px;
        transition: .25s;
    }

    .hamburger-btn span:nth-child(3) {
        width: 9px;
    }

    .hamburger-btn.active span:nth-child(1) {
        transform: rotate(45deg) translate(4px, 4px);
    }

    .hamburger-btn.active span:nth-child(2) {
        opacity: 0;
    }

    .hamburger-btn.active span:nth-child(3) {
        transform: rotate(-45deg) translate(4px, -4px);
        width: 18px;
    }

    .to-top {
        visibility: hidden;
        position: fixed;
        bottom: 90px;
        right: 90px;
        width: 70px;
        height: 70px;
        border: 1px solid white;
        border-radius: 50%;
        cursor: pointer;
        z-index: 10;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: .25s;
    }

    .to-top:hover {
        background: white;
    }

    .to-top:hover img {
        filter: brightness(0);
    }

    .to-top.visible {
        opacity: 1;
        visibility: visible;
    }

    .logo-mobile {
        display: none;
    }

    .header :global(.avatar) {
        display: none;
    }

    .games-widget {
        display: none;
    }

    .cookie-window {
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        background: #1F1D36;
        padding: 10px 0;
        backdrop-filter: blur(300px);
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);
    }

    .cookie-window .container {
        display: flex;
        align-items: center;
    }

    .cookie-text {
        font-size: 13px;
        line-height: 22px;
        color: white;
        margin: 0 150px 0 30px;
        width: 100%;
    }

    .cookie-text :global(a) {
        color: white;
    }

    .cookie-button :global(.btn-primary) {
        text-transform: uppercase;
        white-space: nowrap;
    }

    .header :global(.menu-item.login-btn) {
        padding: 14px 20px;
        box-shadow: inset 0 0 0 1px white;
        border-radius: 6px;
        font-weight: 500;
        margin-right: 20px;
    }

    .header :global(.menu-item.login-btn:after) {
        display: none;
    }

    .game-app-icon img {
        width: 50px;
        border-radius: 50%;
        border: 1px solid #a6a6a6;
    }

    .footer .menu {
        height: 100%;
        align-items: center;
        display: flex;
    }

    .mint-item {
        color: #FF5D1C;
        font-weight: 600;
    }

    @media (max-width: 1550px) {
        .home-page .header {
            width: 1340px;
        }
    }

    @media(max-width: 1400px) {
        .home-page .header {
            width: 1200px;
        }

        .header .menu {
            margin-left: 40px;
        }

        .footer :global(.menu-item:not(:last-child)) {
            margin-right: 60px;
        }

        .to-top {
            right: 40px;
        }
    }

    @media(max-width: 1200px) {
        .header .menu {
            margin-left: 20px;
        }

        .home-page .header {
            width: 960px;
        }

        .header :global(.menu-item) {
            font-size: 16px;
            margin-right: 18px;
        }

        .footer-logotype {
            width: 150px;
        }

        .footer :global(.menu-item:not(:last-child)) {
            margin-right: 20px;
        }

        .footer :global(.menu-item) {
            margin-right: 35px;
            font-size: 16px;
        }

        .footer .logo img {
            max-width: 100%;
        }
    }

    @media(max-width: 991px) {
        .home-page .header .menu :global(.menu-item) {
            padding: 28px 0;
        }

        .home-page .header {
            height: 70px;
        }

        .header .menu {
            margin-left: 0;
        }

        .footer :global(.social-link:not(:last-child)) {
            margin-right: 20px;
        }

        .menu-item-dropdown-list {
            min-width: 150px;
        }

        .header :global(.menu-item) {
            font-size: 14px;
            line-height: 15px;
        }

        .header :global(.menu-item .menu-item-dropdown-title .menu-arrow) {
            margin: 4px 0 0 5px;
        }

        .menu-dropdown-item {
            font-size: 14px;
        }

        .header :global(.menu-item:not(:last-child)) {
            margin-right: 10px;
        }

        .logotype {
            width: 110px;
        }

        .header :global(.btn-primary.register-btn) {
            padding: 10px 12px;
            font-size: 14px;
            line-height: 18px;
        }

        .header :global(.btn-primary.account-btn) {
            display: none;
        }

        .footer :global(.menu-item) {
            font-size: 16px;
        }

        .to-top {
            bottom: 60px;
            right: 50px;
            width: 50px;
            height: 50px;
        }

        .cookie-text {
            margin: 0 15px;
            width: 100%;
        }

        .cookie-icon img {
            width: 60px;
        }

        .header :global(.menu-item.login-btn) {
            padding: 10px 12px;
            font-size: 14px;
            line-height: 18px;
        }

        .header :global(.menu .menu-item:nth-child(5)) {
            display: none;
        }

        .home-page .header {
            width: 100%;
            left: auto;
            top: 0;
            transform: none;
            border-radius: 0;
        }

        .home-page .hamburger-btn {
            top: 12px;
        }
    }

    @media(max-width: 767px) {
        .header {
            height: 62px;
            background: #01070A;
            z-index: 10;
        }

        .home-page .header .menu :global(.menu-item) {
            padding: 20px 12px;
        }

        .home-page .header {
            height: 62px;
        }

        .header :global(.menu-item) {
            display: block;
            width: 100%;
            border-bottom: 2px solid #A0AEC0;
            position: relative;
            transition: .25s;
            font-size: 36px;
            text-align: left;
            font-weight: 600;
            padding: 20px 12px;
            line-height: normal;
        }

        .header :global(.menu-item.login-btn) {
            border-bottom: 0;
        }

        .header :global(.menu .menu-item:nth-child(5)) {
            display: block;
        }

        .header :global(.btn-primary.account-btn),
        .header :global(.btn-primary.register-btn) {
            padding: 10px 10px;
            font-size: 14px;
            white-space: nowrap;
            margin-left: 10px;
        }

        .header .menu .social-links {
            margin-top: 30px;
            text-align: center;
        }

        .menu .social-links a {
            color: white;
            font-size: 20px;
            display: inline-block;
            margin-left: 50px;
            line-height: 20px;
            vertical-align: top;
            opacity: 0.7;
            transition: .25s;
        }

        .logo-pc {
            display: none;
        }

        .logo-mobile {
            display: block;
            width: 40px;
            height: 40px;
        }

        .footer {
            margin: 40px 0 0;
            padding-bottom: 40px;
        }

        .footer-link {
            font-size: 13px;
            margin: 24px auto;
            display: block;
            text-align: center;
        }

        .copyright {
            font-size: 12px;
            text-align: center;
            color: #7d7773;
        }

        .header-menu a {
            display: block;
            color: #1c1d21;
            font-size: 20px;
            padding: 0;
            margin: 20px 0;
            text-align: center;
            font-weight: 500;
        }

        .header .menu {
            display: none;
            background: linear-gradient(272deg, #14141E 0%, #2A1D27 71%);
        }

        .footer :global(.menu-item) {
            font-size: 14px;
            color: #808384;
            line-height: normal;
        }

        .footer :global(.menu-item) {
            margin: 8px 10px !important;
            font-size: 15px;
            color: #bfbbb9;
        }

        .footer :global(.footer-link:not(:last-child)) {
            margin-right: 20px;
        }

        .footer :global(.footer-link) {
            font-size: 14px;
            line-height: normal;
            margin: 0;
            display: inline-block;
        }

        .footer .menu {
            width: 100%;
            height: auto;
            margin: 30px 0;
            flex-wrap: wrap;
            justify-content: center;
        }

        .footer .logo img {
            max-width: 150px;
            margin: 0;
        }

        .menu .social-links {
            margin: 50px 12px 0;
        }

        .social-links a {
            font-size: 20px;
            margin-left: 0;
        }

        .header .menu.active {
            display: block;
            position: absolute;
            top: 62px;
            left: 0;
            margin: 0;
            width: 100%;
            height: calc(100vh - 62px);
            overflow: auto;
            padding-top: 1px;
        }

        .header :global(.menu-item:not(:last-child)) {
            margin-right: 0;
        }

        .header :global(.menu-item:last-child) {
            border-bottom: 0;
        }

        .header :global(.menu-item:before) {
            content: "";
            border-top: 1px solid transparent;
            position: absolute;
            width: 100%;
            left: 0;
            top: -1px;
            transition: .25s;
        }

        .header :global(.menu-item:after) {
            content: "";
            border-bottom: 1px solid transparent;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -1px;
            transition: .25s;
        }

        .header :global(.menu-item:hover) {
            color: #FF5D1C;
        }

        .header .menu .social-links {
            margin-top: 30px;
            text-align: center;
        }

        .footer hr {
            margin: 30px 0;
        }

        .after-footer-links {
            text-align: center;
            margin-bottom: 30px;
        }

        .d-mobile-reverse {
            flex-direction: column-reverse;
        }

        .account-text {
            display: none;
        }

        .header :global(.avatar) {
            display: flex;
            width: 40px;
            height: 40px;
            background: #282d39;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            font-size: 22px;
            font-family: 'Anton', sans-serif;
            color: white;
            text-transform: uppercase;
            text-decoration: none;
        }

        .to-top {
            right: 15px;
            bottom: 20px;
            width: 60px;
            height: 60px;
        }

        .to-top.visible {
            background: rgba(1, 7, 10, 0.6);
            backdrop-filter: blur(3px);
        }

        .to-top.visible:hover {
            background: white;
        }

        .games-widget {
            position: fixed;
            display: block;
            right: 15px;
            bottom: 20px;
            z-index: 9;
        }

        .widget-content {
            background: #282D39;
            width: 100%;
            height: 70px;
            position: absolute;
            bottom: 0;
            padding-top: 10px;
            border-radius: 70px;
            visibility: hidden;
            opacity: 0;
            transition: .25s;
        }

        .widget-content.active {
            height: 352px;
            box-shadow: 0 0 7px rgba(255, 255, 255, 0.1);
            opacity: 1;
            visibility: visible;
        }

        .widget-icon {
            width: 70px;
            height: 70px;
            background: #A0AEC0;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 8px;
            position: relative;
        }

        .game-app-icon {
            margin: 0 0 12px;
            text-align: center;
            display: block;
            color: white;
            text-decoration: none;
            opacity: 0;
            transition: .35s;
        }

        .widget-content.active .game-app-icon {
            opacity: 1;
        }

        .game-app-icon div {
            font-size: 10px;
            line-height: 13px;
            font-weight: 300;
            margin-top: 3px;
        }

        .cookie-window .container {
            flex-wrap: wrap;
        }

        .cookie-window {
            padding: 15px 8px 20px;
        }

        .cookie-button :global(.btn-primary) {
            width: 100%;
        }

        .cookie-text {
            margin: 10px 0 20px;
        }

        .cookie-icon img {
            width: 50px;
        }

        .cookie-button {
            width: 100%;
        }

        .header :global(.menu-item .menu-item-dropdown-title .menu-arrow) {
            margin: 13px 0 0 10px;
            width: 25px;
            transform: rotate(90deg);
        }

        .header :global(.menu-item.open .menu-item-dropdown-title .menu-arrow) {
            transform: rotate(180deg);
        }

        .menu-item-dropdown-list {
            position: relative;
            background: none;
            border-radius: 0;
            padding: 10px;
            box-shadow: none;
            border: 0;
        }

        .menu-dropdown-item {
            font-size: 30px;
            color: #A0AEC0;
            text-transform: uppercase;
            border-bottom: 2px solid transparent;
        }

        .menu-dropdown-item + .menu-dropdown-item {
            margin-top: 28px;
        }

        .menu-dropdown-item:hover {
            color: #FF5D1C;
        }

        .header :global(.menu-item .menu-item-dropdown-title:hover) {
            color: white;
        }

        .social-links {
            margin-top: 15px;
        }

        .footer hr {
            display: none;
        }

        .footer :global(.logo) {
            text-align: left;
        }

        .footer :global(.social-link:not(:last-child)) {
            margin-right: 10px;
        }

        .menu .social-links a {
            font-size: 22px;
            margin: 0 15px;
        }

        .menu .social-links {
            justify-content: center;
        }

        .menu .social-links a:hover {
            opacity: 1;
        }
    }
</style>
